'use client';

import { useEffect, useRef, useState } from 'react';

export default function Home() {
  const [result, setResult] = useState('');
  const scannerRef = useRef<any>(null);
  const isProcessing = useRef(false);

  useEffect(() => {
    let scanner: any;

    const loadScanner = async () => {
      const { Html5QrcodeScanner } = await import('html5-qrcode');

      scanner = new Html5QrcodeScanner(
        'reader',
        {
          fps: 10,
          qrbox: 250,
        },
        false
      );

      scanner.render(
        async (decodedText: string) => {
          if (isProcessing.current) return;

          isProcessing.current = true;

          try {
            setResult(decodedText);

            const response = await fetch('/api/open-door', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                order_no: decodedText,
              }),
            });

            const data = await response.json();

            console.log(data);

            setTimeout(() => {
              isProcessing.current = false;
            }, 3000);

          } catch (err) {
            console.error(err);
            isProcessing.current = false;
          }
        },
        () => {}
      );

      scannerRef.current = scanner;
    };

    loadScanner();

    return () => {
      scannerRef.current?.clear().catch(console.error);
    };
  }, []);

  const testApi = async () => {
    try {
      const response = await fetch('/api/open-door', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          order_no: 'TEST123',
        }),
      });

      const data = await response.json();

      console.log('SUCCESS:', data);

    } catch (err) {
      console.error('ERROR:', err);
    }
  };
  return (
    <main className="min-h-screen bg-gray-100 flex flex-col items-center justify-center p-6">
      
      <h1 className="text-3xl font-bold mb-6">
        QR Scanner
      </h1>

      <div
        id="reader"
        className="w-[320px] overflow-hidden rounded-xl shadow-lg bg-white p-2"
      />

      <div className="mt-6 text-2xl font-bold text-blue-600 break-all text-center">
        {result}
      </div>
      <button
        onClick={testApi}
        className="mt-4 px-4 py-2 bg-blue-500 text-white rounded"
      >
        Test Open Door
      </button>
    </main>
  );
}